<template>
  <v-app class="bgLightGreen boiler-page" id="inspire">
    <Header back header-text="lng_boiler_timer"></Header>
    <flash-message
      v-if="alertToggle"
      :message-data="flashMessageData"
      :alert-toggle="alertToggle"
      :do-translation="false"
      @alertToggleUpdate="flashMessageTimeOut()"
    ></flash-message>
    <div>
      <weather-time-table-per-hour
        v-if="weeklyTimingsData"
        :timings-data="weeklyTimingsData"
        @swapItems="swapItems(...arguments)"
        @selectAllTimeTableData="selectAllTimeTableData"
        @clearAllTimeTableData="clearAllTimeTableData"
        @copyMondayTimeTableData="copyMondayTimeTableData"
        @saveTimeTableData="saveTimeTableData"
      />
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import GlobalService from "../services/global-service";
import FlashMessage from "../components/FlashMessage";
import { translate } from "../common/HelperFunctions";
import { weeklyTimings } from "../common/TimeTableData";
import WeatherTimeTablePerHour from "../components/WeatherTimeTablePerHour";

const fieldKeys = {
  "1": ["a20","a21","a22","a23","a24","a25","a26","a27","a28","a29","b20","b21","b22","b23","b24","b25","b26","b27","b28","b29","c20","c21","c22","c23"],
  "2": ["c24","c25","c26","c27","c28","c29","d20","d21","d22","d23","d24","d25","d26","d27","d28","d29","e20","e21","e22","e23","e24","e25","e26","e27"],
  "3": ["e28","e29","f20","f21","f22","f23","f24","f25","f26","f27","f28","f29","g20","g21","g22","g23","g24","g25","g26","g27","g28","g29","h20","h21"],
  "4": ["h22","h23","h24","h25","h26","h27","h28","h29","i20","i21","i22","i23","i24","i25","i26","i27","i28","i29","j20","j21","j22","j23","j24","j25"]
};

export default {
  components: {
    Header,
    FlashMessage,
    WeatherTimeTablePerHour
  },
  data: () => ({
    userMenuData: undefined,
    alertToggle: false,
    flashMessageData: {},
    responseObj: {},
    pageRefreshTime: 30,
    timerKey: 0,
    timings: undefined,
    weeklyTimingsData: weeklyTimings,
    reductionValue: 0,
    weatherNumber: 1
  }),
  async created() {
    // start page loading component
    let urlData = window.location.href.split("/");
    this.weatherNumber = urlData[urlData.length - 1];
    this.$store.commit("global/setLoading", true);
    await this.FetchApisData();
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    async FetchApisData() {
      this.userMenuData = await GlobalService.getMenuData(
        this.weatherNumber === "1" ? `weather` : `weather${this.weatherNumber}`,
        this.getUser.token
      );
      this.timings =
        this.weatherNumber === "1"
          ? this.userMenuData["weather.timings"].val
          : this.userMenuData[`weather${this.weatherNumber}.timings`].val;
      // this.timings = {"a10":85,"a11":4181,"a12":2048,"a13":2048,"a14":2048,"a15":0,"a16":0,"a17":0,"a18":0,"a19":0,"b10":0,"b11":0}
      this.reductionValue = this.userMenuData[`weather${this.weatherNumber}.night`]
        ? this.userMenuData[`weather${this.weatherNumber}.night`].val
        : 0;

      await this.initTimingData();
      this.$store.commit("global/setLoading", false);
    },
    // to show the resposne alert on update field
    setResponseAlert(resObj) {
      this.alertToggle = true;
      this.responseObj = resObj;
      this.flashMessageData = {
        saved: resObj.onlineandsaved ? "lng_save_ok" : "lng_save_notok",
        messageText: resObj.onlineandsaved
          ? `${translate("lng_save_ok")}`
          : `${translate("lng_save_notok")}`,
        showRegisterButton: false,
        color: resObj.onlineandsaved ? "rgba(76, 175, 80, 0.9)" : "red"
      };
      if (resObj.secs_to_next_update > 0) {
        this.pageRefreshTime = resObj.secs_to_next_update;
      }
      this.timerKey += 1;
    },
    flashMessageTimeOut() {
      this.alertToggle = false;
      this.responseObj = {};
    },
    swapItems(dayId, hourId) {
      let value = this.weeklyTimingsData.days[dayId].hours[hourId].value;
      this.weeklyTimingsData.days[dayId].hours[hourId].value =
        value === 0 ? "-" + this.reductionValue : value === 1 ? 0 : 1;
    },
    async initTimingData() {
      let bitData = [];
      let index = 0;
      let dayIndex = 0;
      let hourIndex = 0;

      let sortedKeys = fieldKeys[this.weatherNumber];
      for (let k=0; k < sortedKeys.length; k++) {

        if (this.timings.hasOwnProperty(sortedKeys[k])) {
          let value = this.timings[sortedKeys[k]];
          let current = parseInt(value);
          let result = [];

          for (let i = 0; i < 7; i++) {
            // set the current bit and place it in its day/hour
            // result[i] = (current >> i) & 1; // jshint ignore:line
            // this.weeklyTimingsData.days[dayIndex].hours[hourIndex].value =
            //   result[i];

            let timeKey = current & 3;
            current = current >> 2;
            switch (timeKey) {
              case 0:
                this.weeklyTimingsData.days[dayIndex].hours[
                  hourIndex
                ].value = timeKey;
                break;
              case 1:
                this.weeklyTimingsData.days[dayIndex].hours[
                  hourIndex
                ].value = timeKey;
                break;
              case 2:
                this.weeklyTimingsData.days[dayIndex].hours[hourIndex].value =
                  "-" + this.reductionValue;
                break;
            }

            // increment
            dayIndex++;
            index++;
            // iterate through 7 bits then increment the hour that is being processed
            if (index === 7) {
              hourIndex++;
              index = 0;
            }
            if (dayIndex === 7) {
              dayIndex = 0;
            }
          }

          bitData.push.apply(bitData, result);
        }
      }
    },
    async encode() {
      let str = "{";
      let fields = fieldKeys[this.weatherNumber];
      
      let tableRowIndex = 0;

      for (let j = 0; j < fields.length; j++) {
        let compressedTime = 0;
        if (j > 0) {
          str += ",";
        }
        for (let i = 6; i >= 0; i--) {
          let timevalue;
          compressedTime = compressedTime << 2;
          if (this.weeklyTimingsData.days[i].hours[tableRowIndex].value === 0) {
            timevalue = 0;
          } else if (
            this.weeklyTimingsData.days[i].hours[tableRowIndex].value === 1
          ) {
            timevalue = 1;
          } else if (
            this.weeklyTimingsData.days[i].hours[tableRowIndex].value ===
            "-" + this.reductionValue
          ) {
            timevalue = 2;
          }
          compressedTime = compressedTime | timevalue;
        }
        str += '"' + fields[j] + '":' + compressedTime;
        tableRowIndex = tableRowIndex + 1;
      }
      str += "}";
      return str;
    },
    async saveTimeTableData() {
      let encodedData = await this.encode();
      let response;
      try {
        response = await GlobalService.saveFieldData(
          this.weatherNumber === "1" ? `weather` : `weather${this.weatherNumber}`,
          this.weatherNumber === "1" ? `weather.timings` : `weather${this.weatherNumber}.timings`,
          this.getUser.token,
          encodedData
        );
      } catch (e) {
        let resObj = { status: 1, message: "Try again later" };
        this.setResponseAlert(resObj);
      }
      this.setResponseAlert(response);
    },
    selectAllTimeTableData() {
      // this.weeklyTimingsData= weeklyTimings;
      this.weeklyTimingsData.days.forEach(day => {
        day.hours.forEach(hour => {
          hour.value = 0;
        });
      });
    },
    clearAllTimeTableData() {
      // this.weeklyTimingsData= weeklyTimings;
      this.weeklyTimingsData.days.forEach(day => {
        day.hours.forEach(hour => {
          hour.value = 1;
        });
      });
    },
    copyMondayTimeTableData() {
      for (let i = 1; i < this.weeklyTimingsData.days.length; i++) {
        for (
          let hour = 0;
          hour < this.weeklyTimingsData.days[i].hours.length;
          hour++
        ) {
          this.weeklyTimingsData.days[i].hours[
            hour
          ].value = this.weeklyTimingsData.days[0].hours[hour].value;
        }
      }
    }
  }
};
</script>
